import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-950 border-t border-secondary-800/30">
      <div className="w-full px-4 md:px-6">
        <div className="py-12 md:py-14">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                佐山爱粉丝站
              </h4>
              <p className="text-sm text-secondary-300 leading-relaxed">
                最全面、最权威的佐山爱中文信息查询平台，为粉丝提供个人资料、作品全览及最新动态。
              </p>
            </div>
            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                快速导航
              </h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-sm text-secondary-300 hover:text-background-50 transition-colors cursor-pointer">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/category/gravure" className="text-sm text-secondary-300 hover:text-background-50 transition-colors cursor-pointer">
                    写真作品
                  </Link>
                </li>
                <li>
                  <Link to="/category/film" className="text-sm text-secondary-300 hover:text-background-50 transition-colors cursor-pointer">
                    影视作品
                  </Link>
                </li>
                <li>
                  <Link to="/category/news" className="text-sm text-secondary-300 hover:text-background-50 transition-colors cursor-pointer">
                    最新动态
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                更多内容
              </h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/category/profile" className="text-sm text-secondary-300 hover:text-background-50 transition-colors cursor-pointer">
                    个人资料
                  </Link>
                </li>
                <li>
                  <Link to="/category/interview" className="text-sm text-secondary-300 hover:text-background-50 transition-colors cursor-pointer">
                    访谈专访
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-secondary-300 hover:text-background-50 transition-colors cursor-pointer">
                    关于本站
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                关注我们
              </h4>
              <p className="text-sm text-secondary-300 mb-3">
                获取佐山爱最新资讯
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-800 text-secondary-200 hover:bg-secondary-700 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-800 text-secondary-200 hover:bg-secondary-700 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-800 text-secondary-200 hover:bg-secondary-700 hover:text-background-50 transition-colors cursor-pointer" aria-label="RSS">
                  <i className="ri-rss-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="py-5 border-t border-secondary-800/30 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-400">
            &copy; 2024-2025 佐山爱粉丝站. 本站为非官方粉丝信息聚合平台，所有内容仅供粉丝交流参考。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-secondary-400 hover:text-secondary-200 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-secondary-400 hover:text-secondary-200 transition-colors cursor-pointer">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}